/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EligibleDirectoryContactUser } from './EligibleDirectoryContactUser';
import {
    EligibleDirectoryContactUserFromJSON,
    EligibleDirectoryContactUserFromJSONTyped,
    EligibleDirectoryContactUserToJSON,
    EligibleDirectoryContactUserToJSONTyped,
} from './EligibleDirectoryContactUser';

/**
 * 
 * @export
 * @interface ListEligibleDirectoryContactUsers200Response
 */
export interface ListEligibleDirectoryContactUsers200Response {
    /**
     * 
     */
    data?: Array<EligibleDirectoryContactUser>;
}

/**
 * Check if a given object implements the ListEligibleDirectoryContactUsers200Response interface.
 */
export function instanceOfListEligibleDirectoryContactUsers200Response(value: object): value is ListEligibleDirectoryContactUsers200Response {
    return true;
}

export function ListEligibleDirectoryContactUsers200ResponseFromJSON(json: any): ListEligibleDirectoryContactUsers200Response {
    return ListEligibleDirectoryContactUsers200ResponseFromJSONTyped(json, false);
}

export function ListEligibleDirectoryContactUsers200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEligibleDirectoryContactUsers200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(EligibleDirectoryContactUserFromJSON)),
    };
}

export function ListEligibleDirectoryContactUsers200ResponseToJSON(json: any): ListEligibleDirectoryContactUsers200Response {
    return ListEligibleDirectoryContactUsers200ResponseToJSONTyped(json, false);
}

export function ListEligibleDirectoryContactUsers200ResponseToJSONTyped(value?: ListEligibleDirectoryContactUsers200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(EligibleDirectoryContactUserToJSON)),
    };
}

